
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M8 5.5h8M8 12h8M8 18.5h8"}})]),_c('path',{attrs:{"d":"M4.5 19.5v-15M19.5 19.5v-15"}})])
          )
        }
      }
    